import { useCallback, useEffect } from "react";
import { FeatureDc } from "@evergis/api";

import { useSGisLayerRedraw } from "../../../hooks/sgis/useSGisLayerRedraw";
import { useSGisLayer } from "../../../hooks/sgis/useSGisLayers";
import { ungroupFeature as ungroupFeatureMutation } from "../../../resources/layers";
import { useResetFeatureSelect } from "../../FeatureSelector/hooks/useResetFeatureSelect";

import { FeatureDcExtended } from "../../../ducks/selectFeatures/types";

export const useUngroupFeature = (feature: FeatureDcExtended) => {
  const [mutation, { loading, data }] = ungroupFeatureMutation.use();
  const resetFeatureSelect = useResetFeatureSelect();
  const sgisLayer = useSGisLayer(feature?.layer);
  const redrawLayer = useSGisLayerRedraw(sgisLayer);

  const ungroupFeature = useCallback(async () => {
    if (!feature) {
      return;
    }

    mutation({
      input: {
        layerName: feature.layer,
        feature: feature as FeatureDc,
      },
    });
  }, [feature]);

  useEffect(() => {
    if (!loading && data) {
      resetFeatureSelect();
      redrawLayer();
    }
  }, [loading, data, resetFeatureSelect, redrawLayer]);

  return [ungroupFeature, { loading }] as const;
};
